import React, { createContext, useContext, useMemo } from 'react';
import Box from '@mui/material/Box';
import backarrow from '../../assets/images/backarrow.svg';
import TabNavigationComponent from '../../components/formlib/TabNavigationComponent';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FACESHEET } from '../../routes/Routing';
import { LookUpContext } from '../../context/LookUpContextProvider';
import { Tooltip } from '@mui/material';
import { formatName } from '../../utils/nameUtils';
import ModalPopup from '../../components/formlib/ModalPopup';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';

export interface ClientNameType {
  clientnameString: (value: string) => void;
}

export const ClientContext = createContext<ClientNameType | undefined>(
  undefined,
);

export default function SubHeaderComponent() {
  const navigate = useNavigate();
  const [Client, setClient] = React.useState('');
  const { lookupsDemographics } = useContext(LookUpContext);

  const clientnameString = (value: string) => {
    setClient(value);
  };

  const contextValue: ClientNameType = useMemo(
    () => ({
      clientnameString,
    }),
    [clientnameString],
  );

  const { hasUnsavedChanges, handleUpdateUnsavedChanges } = useContext(
    UnSavedChangesContext,
  );
  const [openUnSavedModal, setOpenUnSavedModal] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    const clientFromLocalStorage = localStorage.getItem('clientName');
    if (clientFromLocalStorage) {
      setClient(clientFromLocalStorage);
    } else {
      setClient('');
    }
  }, [localStorage.getItem('clientName')]);

  React.useEffect(() => {
    const clientFromLocalStorage = localStorage.getItem('clientName');
    if (clientFromLocalStorage) {
      setClient(clientFromLocalStorage);
    } else if (lookupsDemographics !== null) {
      const fullName = formatName(
        lookupsDemographics.firstName,
        lookupsDemographics.middleName,
        lookupsDemographics.lastName,
        lookupsDemographics.suffix,
      );
      setClient(fullName);
    } else {
      setClient('');
    }
  }, [lookupsDemographics]);

  return (
    <ClientContext.Provider value={contextValue}>
      <div style={{ width: '100%' }}>
        <Box component="main" sx={{ flexGrow: 1, bgcolor: '#E7F0F0' }}>
          <Box
            display="flex"
            alignItems={'center'}
            padding={'20px 0px 8px 0px'}
          >
            <button
              type="button"
              onClick={() => {
                const clientId = localStorage.getItem('ClientId');

                if (clientId !== null) {
                  if (hasUnsavedChanges) {
                    setOpenUnSavedModal(true);
                  } else {
                    navigate(FACESHEET);
                    handleUpdateUnsavedChanges(false);
                  }
                }
              }}
              style={{
                border: 'none',
                background: 'transparent',
                padding: 0,
                cursor: 'pointer',
                marginTop: '5px',
              }}
            >
              <img src={backarrow} alt="backarrow" />
            </button>
            <Box className="addnewclient">
              {Client ? (
                <Tooltip
                  title={Client}
                  arrow={true}
                  followCursor
                  placement="bottom"
                >
                  <Box
                    sx={{
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      width: '600px',
                    }}
                  >
                    {Client}
                  </Box>
                </Tooltip>
              ) : (
                <FormattedMessage
                  id="Dashboard.AddClient"
                  defaultMessage="Add New Client"
                />
              )}
            </Box>
          </Box>
          <Box>
            <TabNavigationComponent />
          </Box>
        </Box>
        <ModalPopup
          open={openUnSavedModal}
          description="UnsavedAlertDescriptionWhileLeaving"
          labelId1="UnSavedAlertCancel"
          labelId2="UnSavedAlertLeave"
          negativeActionLabel="No"
          positiveActionLabel="Yes"
          onCancel={() => {
            setOpenUnSavedModal(false);
          }}
          onOk={() => {
            navigate(FACESHEET);
            handleUpdateUnsavedChanges(false);
            setOpenUnSavedModal(false);
          }}
        />
      </div>
    </ClientContext.Provider>
  );
}
